<footer class="layout-grid">
    <!-- Non-edit mode: standard list -->
    <ul *ngIf="!editMode" class="footer__container">
        <ng-container *ngIf="!footerLinks || footerLinks.length === 0">
            <li class="footer__block">
                <div class="skeleton-anchor">&nbsp;</div>
            </li>
            <li class="footer__block">
                <div class="skeleton-anchor">&nbsp;</div>
            </li>
        </ng-container>
        <li class="footer__block" *ngFor="let item of footerLinks; trackBy: trackByFooterLink">
            <a [href]="item.url" target="_blank">{{ item.title }}</a>
        </li>
    </ul>

    <!-- Edit mode: mixed drag drop list -->
    <ul *ngIf="editMode"
        class="footer__container"
        cdkDropListGroup
        mixedCdkDragDrop
        [orientation]="'horizontal'"
        (dropped)="editChange.emit({field: 'footerLinksDropped', event: $event})">
        <span *ngFor="let item of footerLinks; let i = index; trackBy: trackByFooterLink"
              cdkDropList
              mixedCdkDropList
              class="footer-link-drop-wrapper">
            <li class="footer__block edit-mode site-editor-draggable" cdkDrag>
                <!-- Edit mode controls -->
                <app-edit-controls customClass="footer-item-controls"
                                [showLinkIcon]="true"
                                [dragHandleTitle]="'Reorder ' + item.title + ' (use arrow keys)'"
                                [linkIconTitle]="'Edit URL: ' + item.url"
                                [deleteTitle]="'Delete footer link: ' + item.title"
                                [linkEditField]="'footerLinks[' + i + '].url'"
                                [linkEditValue]="item.url"
                                [linkEditEnabled]="editMode"
                                [linkEditConfig]="{ type: 'text', placeholder: 'Enter URL...' }"
                                [linkEditError]="footerLinkUrlErrors[i]"
                                (linkEditChange)="editChange.emit({field: $event.field, value: $event.value, index: i})"
                                (deleteClick)="editChange.emit({field: 'deleteFooterLink', index: i})"
                                (reorder)="editChange.emit({field: 'reorderFooterLink', index: i, direction: $event.direction})"></app-edit-controls>

                <!-- Edit mode elements -->
                <span class="editable-footer-title"
                    [appInlineEdit]="'footerLinks[' + i + '].title'"
                    [inlineEditValue]="item.title"
                    [inlineEditEnabled]="editMode"
                    [inlineEditConfig]="{ type: 'text', placeholder: 'Enter link text...' }"
                    (inlineEditChange)="editChange.emit({field: $event.field, value: $event.value, index: i})"
                    [class.inline-editable-error]="footerLinkTitleErrors[i]"
                    tabindex="0">
                    <span *ngIf="item.title && item.title.trim() !== ''">{{ item.title }}</span>
                    <span *ngIf="(!item.title || item.title.trim() === '') && editMode" class="placeholder-text">Click to add link text...</span>
                </span>
            </li>
        </span>

        <!-- Add new footer link button (only in edit mode) -->
        <li class="footer__block preview-edit-block">
            <button mat-flat-button color="primary" (click)="editChange.emit({field: 'addFooterLink'})">
                <mat-icon>add</mat-icon>
                Add Footer Link
            </button>
        </li>
    </ul>
    <div class="footer__container to-legal-links">
        <p class="legal-text">Powered by Teller Online</p>
        <a *ngIf="!preview" routerLink="/privacy-policy" target="_blank">Privacy Policy</a>
        <span *ngIf="preview">Privacy Policy</span>
    </div>
</footer>